import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Giayvantai from "components/Giayvantai/Giayvantai.js";
export default function GiayVT() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Giấy vận tại",
            tabContent: <Giayvantai />,
          },
        ]}
      />
    </div>
  );
}
